module.exports = __webpack_public_path__ + "static/media/lte3.2437ec9c.png";